"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertor = exports.taskFromOperationNode = void 0;
const common_1 = require("@finley-technologies/common");
const converterUtils_1 = require("../converterUtils");
const types_1 = require("./types");
const taskToOperationNode = (task) => {
    const { srcArtifactSlug: _unused2, ...nodeConfiguration } = task;
    return (0, converterUtils_1.newOperationNode)(types_1.nodeType, nodeConfiguration);
};
const taskFromOperationNode = ({ srcNodes, operationNode, }) => {
    const { configuration } = operationNode;
    (0, common_1.finleyAssert)(srcNodes.length >= 1, `pyCsvVirtualSheet node has [${srcNodes.length}] src nodes`);
    const [srcArtifactSlug] = srcNodes.map((srcNode) => (0, converterUtils_1.getSrcArtifactSlug)(srcNode, 'source node can not be an operation node'));
    return {
        srcArtifactSlug,
        ...configuration,
    };
};
exports.taskFromOperationNode = taskFromOperationNode;
exports.convertor = {
    operation: 'pyCsvVirtualSheet',
    nodeType: types_1.nodeType,
    taskToOperationNode,
    taskFromOperationNode: exports.taskFromOperationNode,
    toTransformation: (task) => {
        const { srcArtifactSlug: _unused, ...restOfParams } = task;
        return {
            isValid: true,
            data: {
                srcDataTape: null,
                ...restOfParams,
            },
        };
    },
};
//# sourceMappingURL=converter.js.map